import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'msToTime',
  standalone: true
})
export class MsToTimePipe implements PipeTransform {

  transform(ms: number | null | undefined): string {
    if (ms == null || ms < 0) return '0s';

    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (minutes === 0) {
      return `${seconds}s`;
    }

    return `${minutes}m ${seconds}s`;
  }
}